import makeStyles from '@mui/styles/makeStyles';
import {isEmpty, map} from 'lodash';
import React from "react";
import {useTranslation} from "react-i18next";
import {color, font, type} from "common/tokens";
import Accordion from "components/redesign/Accordion";
import Card from "components/redesign/Card";

const useStyles = makeStyles({
  page: {
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
  },
  title: {
    ...type.pageTitle,
    color: color.TEXT,
    margin: 0,
  },
  topic: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  topicTitle: {
    ...type.eyebrow,
    fontWeight: font.BOLD,
    letterSpacing: '1.43px',
    color: color.SECTION_TITLE,
    margin: 0,
  },
  question: {
    padding: '16px 20px',
  },
  answer: {
    ...type.body,
    color: color.TEXT_MUTED,
    margin: 0,
    paddingTop: 4,
    whiteSpace: 'pre-line',
  },
  empty: {
    ...type.body,
    color: color.TEXT_MUTED,
    margin: '48px 0',
    textAlign: 'center',
  },
});

const FAQ = ({faqTopics}) => {
  const classes = useStyles();
  const {t} = useTranslation();

  return (
    <div className={classes.page}>
      <h1 className={classes.title}>{t('faqsAndWalks')}</h1>

      {isEmpty(faqTopics) ? (
        <p className={classes.empty}>{t('loading')}</p>
      ) : (
        map(faqTopics, topic => (
          <div className={classes.topic} key={topic.topicTitle}>
            <p className={classes.topicTitle}>{topic.topicTitle}</p>
            {map(topic.content, item => (
              <Card variant={'media'} className={classes.question} key={item.question}>
                <Accordion label={item.question} variant={'plain'}>
                  <p className={classes.answer}>{item.answer}</p>
                </Accordion>
              </Card>
            ))}
          </div>
        ))
      )}
    </div>
  );
};

export default FAQ;
